import { useCustom } from "@refinedev/core";

/**
 * Mints the chatbot/share-link preview credential — BE's dedicated
 * access_token endpoint, distinct from the email/PIN `.../token` endpoint.
 * Lazy: nothing fires until `refetch()` is called (`useOpenPublication`'s
 * Share button).
 */
export const useInstanceAccessToken = ({
  projectId,
  instanceId,
}: {
  projectId: string;
  instanceId: string;
}) => {
  const { refetch } = useCustom({
    method: "get",
    url: `media/projects/${projectId}/instances/${instanceId}/access_token`,
    queryOptions: {
      enabled: false,
    },
  });

  const getAccessToken = async (): Promise<string | undefined> => {
    const { data } = await refetch();
    return data?.data as unknown as string | undefined;
  };

  return { getAccessToken };
};
